/**
 * @internal
 */
export function shortenString(str, extraShort = true) {
    return `${str.substring(0, extraShort ? 4 : 6)}...${str.substring(str.length - (extraShort ? 3 : 4))}`;
}
//# sourceMappingURL=addresses.js.map